/**
 * modal id들을 정리한 오브젝트
 * ```
 *  openModal({ id: MODALS_ID.ALERT })
 *  // or
 *  closeModal(MODALS_ID.ALERT)
 * ```
 */
export const MODALS_ID = {
  ALERT: 'ALERT', // alert
  TERMS_DETAIL: 'TERMS_DETAIL', // 약관 공통 modal
  NETWORK_ERROR: 'NETWORK_ERROR', // 네트워크 에러
  RENDING: 'RENDING', // 첫 rending시 보여지는 modal
  SUCCESS_SIGNUP: 'SUCCESS_SIGNUP', // 회원가입 성공
  LOGOUT: 'LOGOUT', // logout
  WITHDRAWAL_USER_CONFIRM: 'WITHDRAWAL_USER_CONFIRM', // 회원탈퇴
  ALREADY_WITHDRAWAL_NOTIFY: 'ALREADY_WITHDRAWAL_NOTIFY', // 탈퇴 시점 30일 이후부터 재가입 가능해요
  IS_SIGNIN: 'IS_SIGNIN', // 로그인 후 사용이 가능해요
  VERIFICATION_NOTICE: 'VERIFICATION_NOTICE', // 본인인증이 필요합니다
  SUCCESS_VERIFICATION: 'SUCCESS_VERIFICATION', // 본인인증 성공
  ALREADY_VERIFICATION: 'ALREADY_VERIFICATION', // 이미 본인인증이 완료된 계정이 있어요
  MISMATCH_USER: 'MISMATCH_USER', // 본인 명의의 휴대전화만 본인인증 가능
  CHECK_VERIFICATION: 'CHECK_VERIFICATION', // 본인인증후 계좌 개설이 가능해요
  EMPTY_ADDRESS: 'EMPTY_ADDRESS', // 주소 입력이 필요합니다
  SUCCESS_ADDRESS: 'SUCCESS_ADDRESS', // 주소 입력 완료
  POSTCODE: 'POSTCODE', // 다음 주소 입력 modal
  SUCCESS_EMAIL: 'SUCCESS_EMAIL', // 이메일 입력 완료
  CREATE_ACCOUNT: 'CREATE_ACCOUNT', // 입출금 계좌를 생성해주세요
  SUCCESS_CREATED_WITHDRAWAL: 'SUCCESS_CREATED_WITHDRAWAL', // 출금 계좌 등록 완료
  SUCCESS_CHANGED_WITHDRAWAL: 'SUCCESS_CHANGED_WITHDRAWAL', // 출금 계좌 변경 완료
  SUITABLE_NOTICE: 'SUITABLE_NOTICE', // 투자 적합성 테스트가 필요합니다
  INVEST_SUITABILITY: 'INVEST_SUITABILITY', // 투자 적합성 테스트 안내
  ORDER_LOADING: 'ORDER_LOADING', // 청약 로딩
  ORDER_SUCCESS: 'ORDER_SUCCESS', // 청약 성공
  ORDER_FAIL: 'ORDER_FAIL', // 청약 실패
  CANCEL_PRODUCT: 'CANCEL_PRODUCT', // 청약 취소
  CALCULATE: 'CALCULATE', // 매각 대금 정산
  TERMS: 'TERMS', // home 서비스 이용약관
  POLICY: 'POLICY', // home 개인정보처리방침
  DEVICE_NOTIFY_ALLOW: 'DEVICE_NOTIFY_ALLOW', // 기기 알림을 켠 후 이용이 가능합니다
  OPEN_SOURCE: 'OPEN_SOURCE', // 오픈소스 라이브러리
  ORDER_EVENT_NOTICE: 'ORDER_EVENT_NOTICE', // 청약 신청 이벤트 선택 약관 동의 유도 alert
  NOT_SIGNUP: 'NOT_SIGNUP'
} as const

type ModalsIds = keyof typeof MODALS_ID

export type { ModalsIds }
